import { Outlet, Route, Routes } from 'react-router-dom'
// import { ProtectedRoute } from './components/ProtectedRoute'
import { useAuthContext } from './contexts'
import {
  DeviceDetailsPage,
  DevicesPage,
  HomePage,
  LoginPage,
  LogoutPage,
  MapPage,
  PageNotFound,
  RawMessagesPage,
  SensorPage,
  TestMessagePage,
  UserSettingsPage,
} from './pages'
import { NavBar } from './components'
import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css'
import { CreateAccountPage } from './pages/CreateAccountPage'
import { ForgotPasswordPage } from './pages/ForgotPasswordPage'
import { ConfigMessagesPage } from './pages/ConfigMessagesPage'
import { UserPreferences } from './pages/UserPreferences'
import { ContactPage } from './pages/ContactPage'
import { InfoPage } from './pages/InfoPage'
import './index.css'
import { ManageDataPage } from './pages/ManageDataPage'

function App() {
  const { isAuthorized } = useAuthContext()

  return (
    <div>
      <NavBar />
      <Outlet />
      <Routes>
        <Route index element={isAuthorized === undefined ? null : isAuthorized ? <HomePage /> : <LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/logout" element={<LogoutPage />} />
        <Route path="/create-account" element={<CreateAccountPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/create-account" element={<CreateAccountPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/details" element={<DeviceDetailsPage />} />
        <Route path="/devices" element={<DevicesPage />} />
        <Route path="/devices/:deviceId" element={<DeviceDetailsPage />} />
        <Route path="/devices/:deviceId/:sensorId" element={<SensorPage />} />
        <Route path="/home" element={<MapPage />} />
        <Route path="/user-settings" element={<UserSettingsPage />} />
        <Route path="/user-preferences" element={<UserPreferences />} />
        <Route path="/raw-messages" element={<RawMessagesPage />} />
        <Route path="/config-messages" element={<ConfigMessagesPage />} />
        <Route path="/test-messages" element={<TestMessagePage />} />
        <Route path="/manage-data" element={<ManageDataPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/ricster/terms-of-service" element={<InfoPage name="ricster/terms-of-service" />} />
        <Route path="/ricster/privacy-policy" element={<InfoPage name="ricster/privacy-policy" />} />
        <Route path="/flowster/terms-of-service" element={<InfoPage name="flowster/terms-of-service" />} />
        <Route path="/flowster/privacy-policy" element={<InfoPage name="flowster/privacy-policy" />} />
        <Route path="/sensors" element={<SensorPage />} />
        <Route path="/maps" element={<MapPage />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
  )
}

export default App
